module.exports = __webpack_public_path__ + "static/img/SHOKZ.6130483.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/SHOKZ.png
// module id = c4eo
// module chunks = 34